(function() {
    angular.module('emarket.commons').directive('emAccordionExpander', function() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            require: '?^emAccordion',
            scope: {
                title: '@',
                isVisible: '=?'
            },
            templateUrl: 'directives/accordion/em-accordion-expander.tpl.html',
            link: function(scope, element, attrs, emAccordionController) {
                var hasAccordionController = !!emAccordionController;

                scope.isVisible = false;

                scope.handleToggle = function() {
                    scope.isVisible = !scope.isVisible;

                    if (hasAccordionController) {
                        emAccordionController.handleSelectedItem(scope);
                    }
                };

                if (hasAccordionController) {
                    emAccordionController.register(scope);
                }
            }
        };
    });
}());
